import { useEffect, useState } from 'react';
import { AuthBridge } from '../lib/authBridge';
import { registerApplications } from '../single-spa-config';

/**
 * Registers single-spa applications as soon as the import map is available in
 * the DOM. Accepts the auth bridge instance created by AppShell and forwards
 * it to registerApplications, which passes it to each app via customProps.
 */
export const useImportMapReady = (bridge: AuthBridge): void => {
  const [importMapReady, setImportMapReady] = useState(
    () => !!document.querySelector('script[type="importmap"]')
  );

  useEffect(() => {
    if (importMapReady) {
      registerApplications(bridge);
      return;
    }

    const onReady = () => setImportMapReady(true);
    document.addEventListener('importmapready', onReady);
    return () => document.removeEventListener('importmapready', onReady);
  }, [importMapReady, bridge]);
};
